import { gql } from '@apollo/client';

export const OfferCreationQuery = gql`
  query ActiveOffersPropertyQuery($addressToken: String!) {
    buyer {
      getPropertyByAddressId(input: { addressId: $addressToken }) {
        property {
          id
          addressId
          bathroomsTotal
          bedrooms
          currentListPrice
          marketIdentifier
          oboEligible
          paramsId
          photos {
            urls {
              size768x512
            }
          }
          street
          totalLivingSqFt
        }
      }
      getOffersForCurrentUser(input: { paginationRequest: { first: 50 }, offerFilters: ACTIVE }) {
        offers {
          id
          agent {
            email
            headshotUrl
            name
          }
          buyerAgentConfirmed
          property {
            addressId
          }
        }
      }
      getCurrentUser {
        user {
          id
          email
          learnMoreRequested
          name
          phone
        }
      }
    }
  }
`;
